import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import ConfiguratorImage from './../ConfiguratorImage'
import ConfiguratorOption from './../ConfiguratorOption'
import TransomConfigurator from './../TransomConfigurator'
import RadioGroup from './../RadioGroup'
import { withTranslation, Trans } from 'react-i18next'
import { view01ImageOptions } from './views/view01'

class X46Mast extends Component {
  constructor (props) {
    super(props)
    this.handleMastAndBoomChange = this.handleMastAndBoomChange.bind(this)
  }

  handleMastAndBoomChange (newValue) {
    let configuration = this.props.configuration
    configuration.MastAndBoom = newValue

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  render () {
    let imageOptions = view01ImageOptions

    let image = (
      <TransomConfigurator
        colorMultiplier={0.75}
        name={this.props.transom.Name}
        port={this.props.transom.Port}
        transomSize={{ width: 2895, height: 780 }}
        transform={[
          0.062357, -0.000963, 0, -2.3e-5, 0.003397, 0.097934, 0, 5.6e-6, 0, 0,
          1, 0, 220.028066, 404.093037, 0, 1
        ]}
      >
        <ConfiguratorImage
          boat='X4_6'
          configuration={this.props.configuration}
          options={imageOptions}
        />
      </TransomConfigurator>
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption>
          <h1>
            <Trans defaults='Mast & boom' />
          </h1>

          <h2>
            <Trans defaults='Finish' />
          </h2>

          <RadioGroup
            options={this.props.mastAndBoomOptions}
            value={this.props.configuration.MastAndBoom}
            onChange={this.handleMastAndBoomChange}
          />

          <p>
            <Trans defaults='**for optional furlerboom, please contact your local X-Yachts Dealer.' />
          </p>
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(X46Mast)



// WEBPACK FOOTER //
// ./src/X46/X46Mast.js